import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerCompanyIdAtom, routerOrderIdAtom} from "./routerStore";
import {getOrderById} from "../services/orderService";
import {Order} from "../types/domain/order";

/**
 * Retrieving Active Order for Id retrieved from URL
 */
export const activeOrderAtom = atomWithRefresh<Promise<Order | undefined>>(async (get) => {
    const activeCompanyId = get(routerCompanyIdAtom);
    const activeOrderId = get(routerOrderIdAtom);

    return activeCompanyId !== undefined && activeOrderId !== undefined
        ? await getOrderById(activeCompanyId, activeOrderId)
        : undefined;
});

export const activeOrderLoadable = loadable(activeOrderAtom);
